import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getHeaders } from "./getHeaders";

export const getLogin = createAsyncThunk(
  "Auth/getLogin",
  async (resD, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/login`,
          {
            ...resD,
          },
          {
            headers: getHeaders(),
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getLogout = createAsyncThunk(
  "Auth/getLogout",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/logout`,
          {},
          {
            headers: getHeaders(),
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const AuthSlice = createSlice({
  name: "Auth",
  initialState: {
    isAuthLoading: false,
    error: null,
    LoginArr: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // getLogin
      .addCase(getLogin.pending, (state) => {
        state.isAuthLoading = true;
      })
      .addCase(getLogin.fulfilled, (state, action) => {
        state.LoginArr = action.payload.data;
        state.isAuthLoading = false;
      })
      .addCase(getLogin.rejected, (state, action) => {
        state.isAuthLoading = false;
        state.error = action.payload; // يمكن إضافة هذا السطر لتخزين الخطأ
      })

      // getLogout
      .addCase(getLogout.pending, (state) => {
        state.isAuthLoading = true;
      })
      .addCase(getLogout.fulfilled, (state) => {
        state.isAuthLoading = false;
        state.LoginArr = null; // خيار جيد لتفريغ البيانات عند تسجيل الخروج
      })
      .addCase(getLogout.rejected, (state, action) => {
        state.isAuthLoading = false;
        state.error = action.payload;
      });
  },
});

export default AuthSlice.reducer;
